import { RootState } from 'theSource/app/store';

export const selectNativeAuth = (state: RootState) =>
  state.theSource.nativeAuth;
